var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJamfProtect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.23 11.1074C12.4472 11.1109 11.8153 11.7484 11.8189 12.5312L11.863 22.3321C11.8665 23.0952 12.4878 23.7111 13.2509 23.7075L18.1905 23.6852C20.4516 23.6751 23.5537 23.1968 24.3882 19.1778C24.3887 19.1769 25.2173 15.1532 25.7085 12.7681C25.8909 11.881 25.2107 11.0534 24.3051 11.0574L13.23 11.1074Z",
    fill: "#444444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1542 15.6705C28.8187 15.6856 26.8542 17.0991 25.9701 20.1181C25.9718 20.112 23.6794 27.3076 23.6794 27.3076C22.8382 29.6708 21.4714 30.6491 18.9687 30.6604L13.2268 30.6863C12.4944 30.6895 11.9035 31.2859 11.9068 32.0185L11.9232 35.6802C11.9265 36.3805 12.4968 36.9459 13.1972 36.9429L36.5012 36.8377C37.2321 36.8344 37.8219 36.2392 37.8187 35.5085L37.7348 16.9213C37.7316 16.2167 37.158 15.648 36.4531 15.6513L32.1542 15.6705Z",
    fill: "#444444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJamfProtect);
export default __webpack_public_path__ + "static/media/JamfProtect.384d41898f6f27ad0132431d0e14e68a.svg";
export { ForwardRef as ReactComponent };